import { IEntityFetchFailure, IEntityFetchSuccess, IRequestFailure } from "../actions";

export enum RecurlyCouponType {
  Percent = "percent",
  Dollars = "dollars",
}

export interface IRecurlyCouponDiscount {
  type: RecurlyCouponType;
  value: number;
  suffixValue: string;
}

export enum RecurlyCouponDuration {
  Forever = "forever",
  SingleUse = "single_use",
  Temporal = "temporal",
}

export interface IRecurlyCoupon {
  code: string;
  discount: IRecurlyCouponDiscount;
  duration: RecurlyCouponDuration;
  redeemed: boolean;
  appliesToAllPlans?: boolean;
  appliesForMonths?: number;
  plans?: string[];
  plansNames?: string[];
  redemptions?: IRecurlyCouponRedemption[];
}

export interface IRecurlyCouponRedemption {
  couponCode: string;
  singleUse: boolean;
  state: string;
  totalDiscountedInCents: number;
}

export interface IFetchRecurlyCouponPayload {
  planCode: string;
  agents: number;
}

export interface ICheckRecurlyCouponPayload {
  couponName: string;
  couponRedemptions?: IRecurlyCouponRedemption[];
  planCode: string;
  agents: number;
}

export type IConfigureRecurlyFailurePayload = IRequestFailure;

export type ICheckRecurlyCouponSuccessPayload = IEntityFetchSuccess<IRecurlyCoupon>;
export type ICheckRecurlyCouponFailurePayload = IEntityFetchFailure;

export type IFetchCouponSuccessPayload = IEntityFetchSuccess<IRecurlyCoupon>;
export type IFetchCouponFailurePayload = IEntityFetchFailure;
